export const APP_STATE = {
  ONLINE: 'online',
  OFFLINE: 'offline',
};
